import React from "react";
import "./Myprojects.css";
import { FaGithub } from "react-icons/fa"; // Import GitHub icon

const Myprojects = () => {
    const projects = [
        {
            title: "Cine AI",
            image: "/image/cineai.png",
            repo: "https://github.com/yashxita/amazon-hack-2025",
            techStack: "FastAPI | SQLite | JWT Authentication | Pydantic",
            description: "A modern movie recommendation platform that combines individual preferences with collaborative filtering to provide personalized movie suggestions."
        },
        {
            title: "Tuberculosis Detection",
            image: "/image/tb.png",
            repo: "https://github.com/MonamiSomSaha/Tuberculosis-Detection",
            techStack: "Pandas | Numpy | Scikit-learn | PyTorch | OpenCV | Pillow",
            description: "A machine learning model built to classify chest X-ray images as either normal or tuberculosis-infected."
        },
        {
            title: "Finance Insight",
            image: "/image/finance.png",
            repo: "https://github.com/Vishy204/Error_422-Unprocessable_Entity_techkriti_finance_hack",
            techStack: "React | Vite | Machine Learning",
            description: "A platform to automate financial story generation from company reports using AI and NLP techniques."
        },
        {
            title: "For Real",
            image: "/image/fr.png",
            repo: "https://github.com/DhruvsChopra/ForReal-Yantra",
            techStack: "Unity | C# | Blender | AR/VR",
            description: "An AR/VR-based simulation that provides an immersive training platform for rescue workers to handle earthquake emergencies in underground subways."
        },
        {
            title: "DevSOC'25 - CodeChef-VIT Portal",
            image: "/image/dashboard.png",
            repo: "https://github.com/CodeChefVIT/devsoc-portal-25",
            techStack: "Next.js | Axios | Zustand | Shadcn",
            description: "A hackathon management portal designed for seamless team registration, problem statements, and result tracking."
        },
        {
            title: "Papers - CodeChef-VIT Portal",
            image: "/image/papers.png",
            repo: "https://github.com/CodeChefVIT/papers-codechef",
            techStack: "Next.js | Tailwind | MongoDB | Mongoose | Cloudinary | Shadcn",
            description: "A website made for the students of VIT, Vellore to seamlessly access past-year papers."
        },
        {
            title: "CookOff'24 - CodeChef-VIT Portal",
            image: "/image/dash.png",
            repo: "https://github.com/CodeChefVIT/cookoff-portal-9.0",
            techStack: "Next.js | TypeScript | Tailwind | React | Axios | Shadcn",
            description: "A portal for a competitive coding event that tests the coding skills of developers across the country."
        },
        {
            title: "True Sight",
            image: "/image/ts.png",
            repo: "https://github.com/Vishy204/sih_2024_deepfake",
            techStack: "Tailwind | Forensic Analysis | LipNet | MesoNet | Gaze Tracker | MFCC | FrequencyNet",
            description: "An advanced deepfake detection framework designed to not only identify manipulated media but also explain why a video is classified as a deepfake."
        },
        {
            title: "Fintropolis",
            image: "/image/fin.png",
            repo:"https://github.com/Ananyajain04/Fintropolis",
            techStack: "React | Tailwind | Node | Express | MongoDB | Machine Learning",
            description: "A comprehensive personal finance management tool aimed at helping users effectively manage their financial health."
        }
    ];

    return (
        <div className="parent">
            <div className="projects-container">
                {projects.map((project, index) => (
                    <div key={index} className="flip-card">
                        <div className="flip-card-inner">
                            <div className="flip-card-front">
                                <a href={project.repo} target="_blank" rel="noopener noreferrer">
                                    <img src={project.image} alt={project.title} />
                                </a>
                            </div>
                            <div className="flip-card-back">
                                <a href={project.repo} target="_blank" rel="noopener noreferrer" className="github-link">
                                    <FaGithub size={22} />
                                </a>
                                <h3>{project.title}</h3>
                                <hr />
                                <h4>{project.techStack}</h4>
                                <hr />
                                <p>{project.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Myprojects;
